module.exports = __webpack_public_path__ + "img/symbol-fraction-left.0fbf6722.png";